import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const DeleteModal = React.memo(({ 
  isOpen, 
  onClose,
  onConfirm,
  title = "Silme Onayı",
  description = "Bu işlem geri alınamaz. Devam etmek istediğinizden emin misiniz?",
  loading = false
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" aria-label="Silme Onayı">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            İptal
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Siliniyor..." : "Sil"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
});

DeleteModal.displayName = 'DeleteModal';

export default DeleteModal;
